<template>
  <div id="app">
    <AppHeader v-if="!isMobileRoute" />
    <MobileHeader v-else />
    <main>
      <router-view />
    </main>

    <section v-if="!isMobileRoute" id="img-9" aria-hidden="true"
      style="background-image:url('https://obs.huahuaeco.com/official/homeBg1.png')">
      <div class="bottom-top">
        <div class="left">
          <img src="https://obs.huahuaeco.com/official/slogan.png" alt="化化网">
        </div>
        <div class="right">
          <div class="texts">
            <div class="row">
              <div class="item">
                <div class="label">市场商务合作</div>
                <div class="value">marketing@huahuaeco.com</div>
              </div>
              <div class="item">
                <div class="label">监督投诉举报</div>
                <div class="value">tousu@huahuaeco.com</div>
              </div>
            </div>
            <div class="row">
              <div class="item">
                <div class="label">服务热线</div>
                <div class="value">0755-86029999或188-2345-2333</div>
              </div>
              <div class="item">
                <div class="label">总部地址</div>
                <div class="value">深圳市福田区深南大道6033号金运世纪大厦8B</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-bottom">
        <div class="bottom-item">深圳市化化科技有限公司</div>
        <div class="bottom-item">Copyright © HUAHUA 化化 保留所有权利</div>
        <div class="bottom-item link" @click="openLicense">营业执照</div>
        <div class="bottom-item link" @click="openPermit">增值电信业务经营许可证</div>
        <div class="bottom-item link" @click="openMiit">粤ICP备2025456954号-2</div>
        <!-- <button type="button" class="img9-btn img9-license" @click="openLicense" aria-label="查看营业执照"></button>
        <button type="button" class="img9-btn img9-permit" @click="openPermit" aria-label="查看经营许可证"></button>
        <button type="button" class="img9-btn img9-miit" @click="openMiit" aria-label="粤ICP备"></button> -->
      </div>
    </section>

    <MobileFooter v-if="isMobileRoute" @open-license="openLicense" @open-permit="openPermit" @open-miit="openMiit" />
    <BackTop :isMobileRoute="isMobileRoute" />
    <SeoStaticImages :images="seoImages" />
  </div>
</template>

<script>
import AppHeader from './components/Header.vue'
import MobileHeader from './components/MobileHeader.vue'
import BackTop from './components/BackTop.vue'
import MobileFooter from './components/MobileFooter.vue'
import SeoStaticImages from './components/SeoStaticImages.vue'

export default {
  components: {
    AppHeader,
    MobileHeader,
    BackTop,
    MobileFooter,
    SeoStaticImages
  },
  data() {
    return {
      seoImages: [
        'https://obs.huahuaeco.com/official/homeBg1.png'
      ]
    }
  },
  computed: {
    isMobileRoute() {
      return this.$route && (this.$route.path === '/m' || this.$route.path.startsWith('/m/'))
    }
  },
  mounted() {
    // 平滑响应视口宽度变化：在切换移动/桌面阈值时自动路由到对应页面
    this._resizeHandler = () => {
      if (this._resizeTimer) clearTimeout(this._resizeTimer)
      this._resizeTimer = setTimeout(() => {
        try {
          const small = window.matchMedia ? window.matchMedia('(max-width: 768px)').matches : (window.innerWidth <= 768)
          const currentlyMobileRoute = this.$route && (this.$route.path === '/m' || this.$route.path.startsWith('/m/'))
          if (small && !currentlyMobileRoute) {
            const path = this.$route.path === '/' ? '/m' : `/m${this.$route.path}`
            this.$router.replace({ path, query: this.$route.query, hash: this.$route.hash })
          } else if (!small && currentlyMobileRoute) {
            const path = (this.$route.path === '/m')
              ? '/'
              : (this.$route.path === '/m/product' ? '/decorationServices' : this.$route.path.replace(/^\/m/, ''))
            this.$router.replace({ path, query: this.$route.query, hash: this.$route.hash })
          }
        } catch (e) { /* ignore */ }
      }, 160)
    }
    window.addEventListener('resize', this._resizeHandler)
  },
  beforeUnmount() {
    if (this._resizeHandler) window.removeEventListener('resize', this._resizeHandler)
    if (this._resizeTimer) clearTimeout(this._resizeTimer)
  },
  methods: {
    openImg(url) {
      const w = window.open(url, '_blank')
      if (w) try { w.opener = null } catch (e) { }
    },
    openLicense() {
      this.openImg('https://obs.huahuaeco.com/official/PDF/化化营业执照副本(1)(1).jpg')
    },
    openPermit() {
      this.openImg('https://obs.huahuaeco.com/official/PDF/化化ICP和EDI证书(增值电信业务经营许可证).pdf')
    },
    openMiit() {
      this.openImg('https://beian.miit.gov.cn/')
    }
  }
}
</script>

<style scoped lang="scss">
#img-9 {
  display: block;
  position: relative;
  background-color: #f6f7f9;
  padding: 0 24px;
  .bottom-top {
    width: min(1200px, 100%);
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: clamp(48px, 7vw, 100px) 0;
    gap: clamp(16px, 3vw, 64px);
    overflow: hidden;
    .left {
      flex: none;
      width: 18%;
      img {
        width: 2.6667rem;
        height: 1.4333rem;
      }
    }
    .right {
      width: 65%;
      flex: none;
      display: flex;
      align-items: center;
      justify-content: center;
      .texts {
        width: min(760px, 100%);
        .row {
          display: flex;
          justify-content: center;
          gap: .8rem;
          flex-wrap: wrap;
          .item {
            flex: 1;
            min-width: 0;
            .label {
              color: #262626;
              font-size: 18px;
              line-height: 1.4;
            }

            .value {
              margin-top: 10px;
              color: #9fabb8;
              font-size: 16px;
              line-height: 1.6;
              max-width: 400px;
            }
          }
        }
        .row:last-child {
          margin-top: 30px;
        }
        
      }
    }
  }

  .bottom-bottom {
    border-top: 1px solid #ebe9e9;
    display: flex;
    padding: 30px 0;
    justify-content: center;
    flex-wrap: wrap;
    gap: 12px 0;
    .bottom-item {
      color: #9FABB8;
      text-align: center;
      font-size: 14px;
      border-right: 1px solid #BFBFBF;
      padding: 0 20px;
      margin-top: 0;
      line-height: 1.6;
    }
    .bottom-item:last-child {
      border-right: none;
    }
    .link {
      cursor: pointer;
    }
  }

  @media (max-width: 1300px) {
    .bottom-top {
      align-items: flex-start;
    }

    .bottom-top .left {
      flex-basis: 120px;
    }
  }

  @media (max-width: 1100px) {
    .bottom-top {
      justify-content: center;
    }

    .bottom-top .right {
      width: 100%;
      padding: 0 100px;
      justify-content: center;
    }

    .bottom-top .right .texts {
      width: 100%;
    }
  }

  @media (max-width: 1200px) {
    .bottom-bottom {
      justify-content: center;
      gap: 10px 0;
    }

    .bottom-bottom .bottom-item {
      padding: 0 16px;
    }
  }

  @media (max-width: 900px) {
    .bottom-bottom {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 12px 20px;
      padding: 24px 0 28px;
    }

    .bottom-bottom .bottom-item {
      width: 100%;
      border-right: 0;
      padding: 0;
    }
  }

  @media (max-width: 768px) {
    min-height: auto;
    padding: 0 20px;

    .bottom-top {
      padding: 40px 0 32px;
      gap: 24px;
    }

    .bottom-top .left {
      flex: none;
    }

    .bottom-top .right .texts .row {
      flex-direction: column;
      gap: 20px;
    }

    .bottom-top .right .texts .row:last-child {
      margin-top: 20px;
    }

    .bottom-top .right .texts .row .item .label {
      font-size: 16px;
    }

    .bottom-top .right .texts .row .item .value {
      font-size: 14px;
      margin-top: 6px;
    }

    .bottom-bottom {
      padding: 20px 0 28px;
      grid-template-columns: 1fr;
      gap: 8px;
    }

    .bottom-bottom .bottom-item {
      padding: 0;
      font-size: 13px;
    }
  }
}

</style>
